/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Artifactory } from '../models/artifactory';
import { ECRArtifactory } from '../models/ecrartifactory';
import { OneTimeWebhook } from '../models/one-time-webhook';
import { ArtifactoryLinkingRequest } from '../models/artifactory-linking-request';
import { ArtifactoryMirror } from '../models/artifactory-mirror';
import { BasicDockerArtifactory } from '../models/basic-docker-artifactory';
import { BasicDockerDTO } from '../models/basic-docker-dto';

/**
 * Ui Artifactory Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiArtifactoryControllerService extends __BaseService {
  static readonly getAllArtifactoriesUsingGET1Path = '/cc-ui/v1/artifactories';
  static readonly createECRArtifactoryUsingPOST1Path =
    '/cc-ui/v1/artifactories';
  static readonly requestArtifactoryLinkingUsingPOSTPath =
    '/cc-ui/v1/artifactories/link-container-registry';
  static readonly createArtifactoryMirrorUsingPOSTPath =
    '/cc-ui/v1/artifactories/mirrors';
  static readonly getArtifactoryByNameUsingGETPath =
    '/cc-ui/v1/artifactories/name/{name}';
  static readonly getRepositoriesByArtifactoryNameUsingGETPath =
    '/cc-ui/v1/artifactories/name/{name}/repos';
  static readonly getTagsByArtifactoryNameUsingGETPath =
    '/cc-ui/v1/artifactories/name/{name}/tags';
  static readonly createBasicDockerArtifactoryUsingPOSTPath =
    '/cc-ui/v1/artifactories/others';
  static readonly updateBasicDockerArtifactoryUsingPOSTPath =
    '/cc-ui/v1/artifactories/others/{artifactoryId}';
  static readonly getAllArtifactoriesForStackUsingGETPath =
    '/cc-ui/v1/artifactories/stack/{stackName}';
  static readonly deleteArtifactoryUsingDELETEPath =
    '/cc-ui/v1/artifactories/v2/{artifactoryId}';
  static readonly getArtifactoryByIdUsingGETPath =
    '/cc-ui/v1/artifactories/{artifactoryId}';
  static readonly updateECRArtifactoryUsingPOSTPath =
    '/cc-ui/v1/artifactories/{artifactoryId}';
  static readonly deleteECRArtifactoryUsingDELETEPath =
    '/cc-ui/v1/artifactories/{artifactoryId}';
  static readonly associateStacksUsingPOSTPath =
    '/cc-ui/v1/artifactories/{artifactoryId}/associate-projects';
  static readonly getRepositoriesUsingGETPath =
    '/cc-ui/v1/artifactories/{artifactoryId}/repos';
  static readonly getTagsUsingGETPath =
    '/cc-ui/v1/artifactories/{artifactoryId}/tags';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * getAllArtifactories
   * @return OK
   */
  getAllArtifactoriesUsingGET1Response(): __Observable<
    __StrictHttpResponse<Array<Artifactory>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/artifactories`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Artifactory>>;
      }),
    );
  }
  /**
   * getAllArtifactories
   * @return OK
   */
  getAllArtifactoriesUsingGET1(): __Observable<Array<Artifactory>> {
    return this.getAllArtifactoriesUsingGET1Response().pipe(
      __map((_r) => _r.body as Array<Artifactory>),
    );
  }

  /**
   * createECRArtifactory
   * @param ecrArtifactory ecrArtifactory
   * @return OK
   */
  createECRArtifactoryUsingPOST1Response(
    ecrArtifactory: ECRArtifactory,
  ): __Observable<__StrictHttpResponse<ECRArtifactory>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = ecrArtifactory;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/artifactories`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ECRArtifactory>;
      }),
    );
  }
  /**
   * createECRArtifactory
   * @param ecrArtifactory ecrArtifactory
   * @return OK
   */
  createECRArtifactoryUsingPOST1(
    ecrArtifactory: ECRArtifactory,
  ): __Observable<ECRArtifactory> {
    return this.createECRArtifactoryUsingPOST1Response(ecrArtifactory).pipe(
      __map((_r) => _r.body as ECRArtifactory),
    );
  }

  /**
   * requestArtifactoryLinking
   * @param artifactoryLinkingRequest artifactoryLinkingRequest
   * @return OK
   */
  requestArtifactoryLinkingUsingPOSTResponse(
    artifactoryLinkingRequest: ArtifactoryLinkingRequest,
  ): __Observable<__StrictHttpResponse<OneTimeWebhook>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = artifactoryLinkingRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/artifactories/link-container-registry`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OneTimeWebhook>;
      }),
    );
  }
  /**
   * requestArtifactoryLinking
   * @param artifactoryLinkingRequest artifactoryLinkingRequest
   * @return OK
   */
  requestArtifactoryLinkingUsingPOST(
    artifactoryLinkingRequest: ArtifactoryLinkingRequest,
  ): __Observable<OneTimeWebhook> {
    return this.requestArtifactoryLinkingUsingPOSTResponse(
      artifactoryLinkingRequest,
    ).pipe(__map((_r) => _r.body as OneTimeWebhook));
  }

  /**
   * createArtifactoryMirror
   * @param artifactoryMirror artifactoryMirror
   * @return OK
   */
  createArtifactoryMirrorUsingPOSTResponse(
    artifactoryMirror: ArtifactoryMirror,
  ): __Observable<__StrictHttpResponse<ArtifactoryMirror>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = artifactoryMirror;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/artifactories/mirrors`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ArtifactoryMirror>;
      }),
    );
  }
  /**
   * createArtifactoryMirror
   * @param artifactoryMirror artifactoryMirror
   * @return OK
   */
  createArtifactoryMirrorUsingPOST(
    artifactoryMirror: ArtifactoryMirror,
  ): __Observable<ArtifactoryMirror> {
    return this.createArtifactoryMirrorUsingPOSTResponse(
      artifactoryMirror,
    ).pipe(__map((_r) => _r.body as ArtifactoryMirror));
  }

  /**
   * getArtifactoryByName
   * @param name name
   * @return OK
   */
  getArtifactoryByNameUsingGETResponse(
    name: string,
  ): __Observable<__StrictHttpResponse<Artifactory>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/artifactories/name/${encodeURIComponent(String(name))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Artifactory>;
      }),
    );
  }
  /**
   * getArtifactoryByName
   * @param name name
   * @return OK
   */
  getArtifactoryByNameUsingGET(name: string): __Observable<Artifactory> {
    return this.getArtifactoryByNameUsingGETResponse(name).pipe(
      __map((_r) => _r.body as Artifactory),
    );
  }

  /**
   * getRepositoriesByArtifactoryName
   * @param params The `UiArtifactoryControllerService.GetRepositoriesByArtifactoryNameUsingGETParams` containing the following parameters:
   *
   * - `name`: name
   *
   * - `artifactType`: artifactType
   *
   * @return OK
   */
  getRepositoriesByArtifactoryNameUsingGETResponse(
    params: UiArtifactoryControllerService.GetRepositoriesByArtifactoryNameUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<string>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.artifactType != null)
      __params = __params.set('artifactType', params.artifactType.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/artifactories/name/${encodeURIComponent(
          String(params.name),
        )}/repos`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<string>>;
      }),
    );
  }
  /**
   * getRepositoriesByArtifactoryName
   * @param params The `UiArtifactoryControllerService.GetRepositoriesByArtifactoryNameUsingGETParams` containing the following parameters:
   *
   * - `name`: name
   *
   * - `artifactType`: artifactType
   *
   * @return OK
   */
  getRepositoriesByArtifactoryNameUsingGET(
    params: UiArtifactoryControllerService.GetRepositoriesByArtifactoryNameUsingGETParams,
  ): __Observable<Array<string>> {
    return this.getRepositoriesByArtifactoryNameUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<string>),
    );
  }

  /**
   * getTagsByArtifactoryName
   * @param params The `UiArtifactoryControllerService.GetTagsByArtifactoryNameUsingGETParams` containing the following parameters:
   *
   * - `repo`: repo
   *
   * - `name`: name
   *
   * - `artifactType`: artifactType
   *
   * @return OK
   */
  getTagsByArtifactoryNameUsingGETResponse(
    params: UiArtifactoryControllerService.GetTagsByArtifactoryNameUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<string>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.repo != null)
      __params = __params.set('repo', params.repo.toString());

    if (params.artifactType != null)
      __params = __params.set('artifactType', params.artifactType.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/artifactories/name/${encodeURIComponent(
          String(params.name),
        )}/tags`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<string>>;
      }),
    );
  }
  /**
   * getTagsByArtifactoryName
   * @param params The `UiArtifactoryControllerService.GetTagsByArtifactoryNameUsingGETParams` containing the following parameters:
   *
   * - `repo`: repo
   *
   * - `name`: name
   *
   * - `artifactType`: artifactType
   *
   * @return OK
   */
  getTagsByArtifactoryNameUsingGET(
    params: UiArtifactoryControllerService.GetTagsByArtifactoryNameUsingGETParams,
  ): __Observable<Array<string>> {
    return this.getTagsByArtifactoryNameUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<string>),
    );
  }

  /**
   * createBasicDockerArtifactory
   * @param basicDockerDTO basicDockerDTO
   * @return OK
   */
  createBasicDockerArtifactoryUsingPOSTResponse(
    basicDockerDTO: BasicDockerDTO,
  ): __Observable<__StrictHttpResponse<BasicDockerArtifactory>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = basicDockerDTO;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/artifactories/others`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<BasicDockerArtifactory>;
      }),
    );
  }
  /**
   * createBasicDockerArtifactory
   * @param basicDockerDTO basicDockerDTO
   * @return OK
   */
  createBasicDockerArtifactoryUsingPOST(
    basicDockerDTO: BasicDockerDTO,
  ): __Observable<BasicDockerArtifactory> {
    return this.createBasicDockerArtifactoryUsingPOSTResponse(
      basicDockerDTO,
    ).pipe(__map((_r) => _r.body as BasicDockerArtifactory));
  }

  /**
   * updateBasicDockerArtifactory
   * @param params The `UiArtifactoryControllerService.UpdateBasicDockerArtifactoryUsingPOSTParams` containing the following parameters:
   *
   * - `basicDockerDTO`: basicDockerDTO
   *
   * - `artifactoryId`: artifactoryId
   *
   * @return OK
   */
  updateBasicDockerArtifactoryUsingPOSTResponse(
    params: UiArtifactoryControllerService.UpdateBasicDockerArtifactoryUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<BasicDockerArtifactory>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.basicDockerDTO;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/artifactories/others/${encodeURIComponent(
          String(params.artifactoryId),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<BasicDockerArtifactory>;
      }),
    );
  }
  /**
   * updateBasicDockerArtifactory
   * @param params The `UiArtifactoryControllerService.UpdateBasicDockerArtifactoryUsingPOSTParams` containing the following parameters:
   *
   * - `basicDockerDTO`: basicDockerDTO
   *
   * - `artifactoryId`: artifactoryId
   *
   * @return OK
   */
  updateBasicDockerArtifactoryUsingPOST(
    params: UiArtifactoryControllerService.UpdateBasicDockerArtifactoryUsingPOSTParams,
  ): __Observable<BasicDockerArtifactory> {
    return this.updateBasicDockerArtifactoryUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as BasicDockerArtifactory),
    );
  }

  /**
   * getAllArtifactoriesForStack
   * @param stackName stackName
   * @return OK
   */
  getAllArtifactoriesForStackUsingGETResponse(
    stackName: string,
  ): __Observable<__StrictHttpResponse<Array<Artifactory>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/artifactories/stack/${encodeURIComponent(
          String(stackName),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Artifactory>>;
      }),
    );
  }
  /**
   * getAllArtifactoriesForStack
   * @param stackName stackName
   * @return OK
   */
  getAllArtifactoriesForStackUsingGET(
    stackName: string,
  ): __Observable<Array<Artifactory>> {
    return this.getAllArtifactoriesForStackUsingGETResponse(stackName).pipe(
      __map((_r) => _r.body as Array<Artifactory>),
    );
  }

  /**
   * deleteArtifactory
   * @param artifactoryId artifactoryId
   */
  deleteArtifactoryUsingDELETEResponse(
    artifactoryId: string,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl +
        `/cc-ui/v1/artifactories/v2/${encodeURIComponent(
          String(artifactoryId),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * deleteArtifactory
   * @param artifactoryId artifactoryId
   */
  deleteArtifactoryUsingDELETE(artifactoryId: string): __Observable<null> {
    return this.deleteArtifactoryUsingDELETEResponse(artifactoryId).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * getArtifactoryById
   * @param artifactoryId artifactoryId
   * @return OK
   */
  getArtifactoryByIdUsingGETResponse(
    artifactoryId: string,
  ): __Observable<__StrictHttpResponse<Artifactory>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/artifactories/${encodeURIComponent(String(artifactoryId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Artifactory>;
      }),
    );
  }
  /**
   * getArtifactoryById
   * @param artifactoryId artifactoryId
   * @return OK
   */
  getArtifactoryByIdUsingGET(artifactoryId: string): __Observable<Artifactory> {
    return this.getArtifactoryByIdUsingGETResponse(artifactoryId).pipe(
      __map((_r) => _r.body as Artifactory),
    );
  }

  /**
   * updateECRArtifactory
   * @param params The `UiArtifactoryControllerService.UpdateECRArtifactoryUsingPOSTParams` containing the following parameters:
   *
   * - `ecrArtifactory`: ecrArtifactory
   *
   * - `artifactoryId`: artifactoryId
   *
   * @return OK
   */
  updateECRArtifactoryUsingPOSTResponse(
    params: UiArtifactoryControllerService.UpdateECRArtifactoryUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<ECRArtifactory>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.ecrArtifactory;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/artifactories/${encodeURIComponent(
          String(params.artifactoryId),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ECRArtifactory>;
      }),
    );
  }
  /**
   * updateECRArtifactory
   * @param params The `UiArtifactoryControllerService.UpdateECRArtifactoryUsingPOSTParams` containing the following parameters:
   *
   * - `ecrArtifactory`: ecrArtifactory
   *
   * - `artifactoryId`: artifactoryId
   *
   * @return OK
   */
  updateECRArtifactoryUsingPOST(
    params: UiArtifactoryControllerService.UpdateECRArtifactoryUsingPOSTParams,
  ): __Observable<ECRArtifactory> {
    return this.updateECRArtifactoryUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as ECRArtifactory),
    );
  }

  /**
   * deleteECRArtifactory
   * @param artifactoryId artifactoryId
   * @return OK
   */
  deleteECRArtifactoryUsingDELETEResponse(
    artifactoryId: string,
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl +
        `/cc-ui/v1/artifactories/${encodeURIComponent(String(artifactoryId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === 'true',
        }) as __StrictHttpResponse<boolean>;
      }),
    );
  }
  /**
   * deleteECRArtifactory
   * @param artifactoryId artifactoryId
   * @return OK
   */
  deleteECRArtifactoryUsingDELETE(
    artifactoryId: string,
  ): __Observable<boolean> {
    return this.deleteECRArtifactoryUsingDELETEResponse(artifactoryId).pipe(
      __map((_r) => _r.body as boolean),
    );
  }

  /**
   * associateStacks
   * @param params The `UiArtifactoryControllerService.AssociateStacksUsingPOSTParams` containing the following parameters:
   *
   * - `stacks`: stacks
   *
   * - `artifactoryId`: artifactoryId
   */
  associateStacksUsingPOSTResponse(
    params: UiArtifactoryControllerService.AssociateStacksUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.stacks;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/artifactories/${encodeURIComponent(
          String(params.artifactoryId),
        )}/associate-projects`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * associateStacks
   * @param params The `UiArtifactoryControllerService.AssociateStacksUsingPOSTParams` containing the following parameters:
   *
   * - `stacks`: stacks
   *
   * - `artifactoryId`: artifactoryId
   */
  associateStacksUsingPOST(
    params: UiArtifactoryControllerService.AssociateStacksUsingPOSTParams,
  ): __Observable<null> {
    return this.associateStacksUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * getRepositories
   * @param artifactoryId artifactoryId
   * @return OK
   */
  getRepositoriesUsingGETResponse(
    artifactoryId: string,
  ): __Observable<__StrictHttpResponse<Array<string>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/artifactories/${encodeURIComponent(
          String(artifactoryId),
        )}/repos`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<string>>;
      }),
    );
  }
  /**
   * getRepositories
   * @param artifactoryId artifactoryId
   * @return OK
   */
  getRepositoriesUsingGET(artifactoryId: string): __Observable<Array<string>> {
    return this.getRepositoriesUsingGETResponse(artifactoryId).pipe(
      __map((_r) => _r.body as Array<string>),
    );
  }

  /**
   * getTags
   * @param params The `UiArtifactoryControllerService.GetTagsUsingGETParams` containing the following parameters:
   *
   * - `repo`: repo
   *
   * - `artifactoryId`: artifactoryId
   *
   * @return OK
   */
  getTagsUsingGETResponse(
    params: UiArtifactoryControllerService.GetTagsUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<string>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.repo != null)
      __params = __params.set('repo', params.repo.toString());

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/artifactories/${encodeURIComponent(
          String(params.artifactoryId),
        )}/tags`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<string>>;
      }),
    );
  }
  /**
   * getTags
   * @param params The `UiArtifactoryControllerService.GetTagsUsingGETParams` containing the following parameters:
   *
   * - `repo`: repo
   *
   * - `artifactoryId`: artifactoryId
   *
   * @return OK
   */
  getTagsUsingGET(
    params: UiArtifactoryControllerService.GetTagsUsingGETParams,
  ): __Observable<Array<string>> {
    return this.getTagsUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<string>),
    );
  }
}

module UiArtifactoryControllerService {
  /**
   * Parameters for getRepositoriesByArtifactoryNameUsingGET
   */
  export interface GetRepositoriesByArtifactoryNameUsingGETParams {
    /**
     * name
     */
    name: string;

    /**
     * artifactType
     */
    artifactType?: 'docker_image' | 'freestyle';
  }

  /**
   * Parameters for getTagsByArtifactoryNameUsingGET
   */
  export interface GetTagsByArtifactoryNameUsingGETParams {
    /**
     * repo
     */
    repo: string;

    /**
     * name
     */
    name: string;

    /**
     * artifactType
     */
    artifactType?: 'docker_image' | 'freestyle';
  }

  /**
   * Parameters for updateBasicDockerArtifactoryUsingPOST
   */
  export interface UpdateBasicDockerArtifactoryUsingPOSTParams {
    /**
     * basicDockerDTO
     */
    basicDockerDTO: BasicDockerDTO;

    /**
     * artifactoryId
     */
    artifactoryId: string;
  }

  /**
   * Parameters for updateECRArtifactoryUsingPOST
   */
  export interface UpdateECRArtifactoryUsingPOSTParams {
    /**
     * ecrArtifactory
     */
    ecrArtifactory: ECRArtifactory;

    /**
     * artifactoryId
     */
    artifactoryId: string;
  }

  /**
   * Parameters for associateStacksUsingPOST
   */
  export interface AssociateStacksUsingPOSTParams {
    /**
     * stacks
     */
    stacks: Array<string>;

    /**
     * artifactoryId
     */
    artifactoryId: string;
  }

  /**
   * Parameters for getTagsUsingGET
   */
  export interface GetTagsUsingGETParams {
    /**
     * repo
     */
    repo: string;

    /**
     * artifactoryId
     */
    artifactoryId: string;
  }
}

export { UiArtifactoryControllerService };
